export default __webpack_public_path__ + "static/media/star_big_full.eccb0f45.svg";